import type { PdfWidgetSnapshot } from "../pdfTypes";
import type { PdfRect } from "../pdfLayout";
import { renderChart } from "./chartPdfRenderer";

export function renderPie(
  snapshot: Extract<PdfWidgetSnapshot, { type: "pie_chart" }>,
  rect: PdfRect,
  scale: number,
  chartImage?: string,
) {
  // Delegate to the chart renderer — the pie widget is captured via ChartSync
  // exactly like a regular chart (Highcharts SVG → PNG).
  return renderChart(
    { type: "chart", title: snapshot.title, summary: snapshot.summary },
    rect,
    scale,
    chartImage,
  );
}
